import React from "react";

export type PriceModeCardProps = {
  title: string;
  description?: string;
  checked: boolean;
  onPress: any;
  labelColor: string;
  isOrange?: boolean;
  closeModal?: () => void;
  setToastMessage?: React.Dispatch<React.SetStateAction<string | null>>;
};

export type ChangeMarkupForProductProps = {
  closeModal?: () => void;
  setToastMessage?: React.Dispatch<React.SetStateAction<string | null>>;
};

export type CardProps = {
  backgroundColor: string;
  borderColor: string;
  isChecked?: boolean;
};

export enum PriceModes {
  WHITE = 1,
  GREEN = 0,
  ORANGE = 2,
}

export enum PAUserSubTabsType {
  All = "all",
  Buy = "buy",
  Memo = "memo",
  Hold = "hold",
  AskQuestion = "ask_question",
  InternalRequest = "internal_request",
  Quote = "quote",
}

export enum ProductTypeNames {
  JEWELRY = "Jewelry",
  LABGROWNJEWELRY = "Lab-Grown Jewelry",
}

export enum ViewType {
  BuyerView = "buyer_view",
  SellerView = "seller_view",
}

export enum PurchasingAgentTypes {
  PurchasingAgent = "purchasing_agent",
  PurchasingAgentSalesPerson = "purchasing_agent_salesperson",
}

export type ChangePriceMarkupModalProps = {
  markupData: ProductWiseMarkupDataSingle;
  isOpen: boolean;
  onModalClose: any;
  markupUnit: string;
  setToastMessage?: React.Dispatch<React.SetStateAction<string | null>>;
};

export type ProductWiseMarkupDataSingle = {
  productTitle: string;
  category: string;
  markup: string | null;
  product_type?: string;
};

export type ProductWiseMarkupData = {
  diamond: ProductWiseMarkupDataSingle;
  lab_grown_diamond: ProductWiseMarkupDataSingle;
  gemstone: ProductWiseMarkupDataSingle;
  jewelry: ProductWiseMarkupDataSingle;
};

export type ChangePriceMarkupInputConatinerProps = {
  markup: string | null;
  product_type?: string;
  onClose: () => void;
  setToastMessage?: React.Dispatch<React.SetStateAction<string | null>>;
};
